import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  // eslint-disable-next-line consistent-return
  async getYears(params) {
    try {
      const response = await axios.get('categories/factYears/all', { params })
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
  },
  // eslint-disable-next-line consistent-return
  async getSemesters(params) {
    try {
      const response = await axios.get('uni/semesters', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  // eslint-disable-next-line consistent-return
  async downloadSummaryLearningBySemesterAndYear(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/hluvReports/reportSummaryLearningBySemesterAndYear',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
  // eslint-disable-next-line consistent-return
  async downloadStatisticLearningBySemesterAndYear(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/hluvReports/reportStatisticLearningBySemesterAndYear',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
  async downloadFullCourseScores(params) {
    try {
      const response = await axios({
        method: 'get',
        url: 'uni/hluvReports/reportFullCourseScore',
        responseType: 'blob',
        params,
      })
      if (response.status.toString() === '200') {
        return response.data
      }
      return null
    } catch (e) {
      handleCatch(e)
    }
  },
}
